/**
 * Mobile-only: one reel at a time + horizontal auto-scroll
 * Section id on live is shopify-section-template--…__section_rnzRUP
 */
(function () {
  const SECTION_SEL = '[id*="section_rnzRUP"]';
  const MQ = window.matchMedia('(max-width: 749px)');

  function getSection() {
    return document.querySelector(SECTION_SEL);
  }

  function getTrack(section) {
    return (
      section.querySelector('.section-content-wrapper.layout-panel-flex--row') ||
      section.querySelector('.section-content-wrapper.layout-panel-flex') ||
      section.querySelector('.section-content-wrapper')
    );
  }

  function clearInline(el) {
    if (!el || !el.dataset.grefiReelsStyled) return;
    el.style.cssText = el.dataset.grefiReelsPrev || '';
    delete el.dataset.grefiReelsStyled;
    delete el.dataset.grefiReelsPrev;
  }

  function forceStyle(el, cssText) {
    if (!el.dataset.grefiReelsStyled) {
      el.dataset.grefiReelsPrev = el.getAttribute('style') || '';
    }
    el.dataset.grefiReelsStyled = '1';
    el.style.cssText = (el.dataset.grefiReelsPrev ? el.dataset.grefiReelsPrev + ';' : '') + cssText;
  }

  function slideWidth(track) {
    const pad = 16;
    return Math.max(240, Math.round(track.clientWidth - pad * 2));
  }

  function applySizes() {
    const section = getSection();
    if (!section) return null;

    const track = getTrack(section);
    if (!track) return null;

    const cards = Array.from(track.children).filter((el) => el.classList.contains('group-block'));

    if (!MQ.matches) {
      clearInline(track);
      cards.forEach((card) => {
        clearInline(card);
        card.querySelectorAll('video, deferred-media, .video-placeholder-wrapper').forEach(clearInline);
      });
      return null;
    }

    const w = slideWidth(track);
    const h = Math.min(Math.round(window.innerHeight * 0.7), Math.round((w * 16) / 9));

    forceStyle(
      track,
      [
        'display:flex!important',
        'flex-direction:row!important',
        'flex-wrap:nowrap!important',
        'flex-flow:row nowrap!important',
        'align-items:stretch!important',
        'justify-content:flex-start!important',
        'gap:0!important',
        'overflow-x:auto!important',
        'overflow-y:hidden!important',
        'scroll-snap-type:x mandatory',
        'scroll-padding-inline:16px',
        '-webkit-overflow-scrolling:touch',
        'scrollbar-width:none',
        'padding-inline:16px!important',
        'width:100%!important',
        'max-width:100%!important',
      ].join(';')
    );

    cards.forEach((card) => {
      forceStyle(
        card,
        [
          'flex:0 0 ' + w + 'px!important',
          'flex-grow:0!important',
          'flex-shrink:0!important',
          'width:' + w + 'px!important',
          'min-width:' + w + 'px!important',
          'max-width:' + w + 'px!important',
          'scroll-snap-align:center',
          'scroll-snap-stop:always',
        ].join(';')
      );

      card.querySelectorAll('deferred-media, .video-placeholder-wrapper').forEach((media) => {
        forceStyle(
          media,
          [
            'display:block!important',
            'width:100%!important',
            'aspect-ratio:9/16!important',
            'height:' + h + 'px!important',
            'min-height:' + h + 'px!important',
            'max-height:' + h + 'px!important',
            'object-fit:cover!important',
            'border-radius:16px',
            'overflow:hidden',
            'background:#111',
          ].join(';')
        );
      });

      card.querySelectorAll('video').forEach((video) => {
        forceStyle(
          video,
          [
            'display:block!important',
            'width:100%!important',
            'height:100%!important',
            'min-height:' + h + 'px!important',
            'object-fit:cover!important',
            'border-radius:16px',
          ].join(';')
        );
        try {
          video.muted = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.play().catch(function () {});
        } catch (e) {}
      });
    });

    return { track: track, cards: cards, width: w };
  }

  function initScroll(ctx) {
    if (!ctx || !ctx.track || ctx.track.dataset.grefiReelsScroll === 'true') return;
    const track = ctx.track;
    track.dataset.grefiReelsScroll = 'true';

    let timer = null;
    let paused = false;
    let index = 0;

    const goTo = (i) => {
      const cards = Array.from(track.children).filter((el) => el.classList.contains('group-block'));
      if (!cards.length) return;
      index = ((i % cards.length) + cards.length) % cards.length;
      const target = cards[index];
      const left = target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });

      cards.forEach((card, n) => {
        const video = card.querySelector('video');
        if (!video) return;
        if (n === index) {
          video.muted = true;
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    };

    const step = () => {
      if (!MQ.matches || paused) return;
      goTo(index + 1);
    };

    const play = () => {
      clearInterval(timer);
      if (!MQ.matches) return;
      timer = setInterval(step, 3500);
    };

    const pause = () => {
      paused = true;
      clearInterval(timer);
    };

    const resume = () => {
      paused = false;
      play();
    };

    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', () => setTimeout(resume, 2800), { passive: true });
    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', resume);

    MQ.addEventListener('change', () => {
      clearInterval(timer);
      const next = applySizes();
      if (MQ.matches && next) {
        index = 0;
        goTo(0);
        play();
      }
    });

    window.addEventListener(
      'resize',
      () => {
        applySizes();
      },
      { passive: true }
    );

    goTo(0);
    play();
  }

  function init() {
    const ctx = applySizes();
    if (ctx) initScroll(ctx);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  setTimeout(init, 500);
})();
